import { createRouter, createWebHashHistory } from 'vue-router'
import Home from '@/components/Home'
import Login from '@/components/Authentication/Login'
import User from '@/components/User/User'
import Company from '@/components/Company/Company'
import LocationOD from '@/components/Location/Location'
import LandBatch from '@/components/LandBatch/LandBatch'
import Income from '@/components/Income/Income'
import Process from '@/components/Process/Process'
import Outcome from '@/components/Outcome/Outcome'
import Agrochemical from '@/components/Agrochemical/Agrochemical'
import NotFound from '@/components/Miscellaneous/NotFound'

/* para hacer Lazy initialization, es decir que se carguen solo cuando son llamadas
Esto es super util cuando la aplicacion empieza a crecer

const Login = () => System.import('../components/Authentication/Login.vue')
const ComercialEntity = () => System.import('../components/Client/ComercialEntity.vue')
const NotFound = () => System.import('../components/Miscellaneous/NotFound.vue')
*/

const router = createRouter({
  history: createWebHashHistory(),
  linkActiveClass: 'is-active', // para que marque el link activo
  scrollBehavior: (to, from, savedPosition) => ({ top: 0 }), // para que al apretar un link vaya a la posicion y = 0 , tambien puede ir a hashtag especificos
  routes: [
    {
      path: '/trabajos-campo/lugares',
      redirect: '/compania'
    },
    {
      path: '/trabajos-campo/:section?',
      name: 'Fieldwork',
      meta: { permissions: ['fieldwork.records.read', 'fieldwork.machinery.read', 'fieldwork.reports.read', 'fieldwork.prices.read'] },
      component: () => import('@/components/Fieldwork/Fieldwork.vue')
    },
    {
      path: '/panol/:section?',
      name: 'Inventory',
      meta: { permissions: ['inventory.stock.read', 'inventory.documents.read', 'inventory.assets.read', 'inventory.items.read', 'inventory.catalogs.read'] },
      component: () => import('@/components/Inventory/Inventory.vue')
    },
    {
      path: '/',
      name: 'Home',
      meta: { permission: 'plant.home.read' },
      component: Home
    },
    {
      path: '/login',
      name: 'Login',
      meta: { public: true },
      component: Login
    },
    {
      path: '/compania',
      name: 'Company',
      meta: { permission: 'catalog.companies.read' },
      component: Company
    },
    {
      path: '/ubicacion',
      name: 'Location',
      meta: { permission: 'catalog.locations.read' },
      component: LocationOD
    },
    {
      path: '/lote',
      name: 'Lotes',
      meta: { permission: 'catalog.lots.read' },
      component: LandBatch
    },
    {
      path: '/usuario',
      name: 'User',
      meta: { permission: 'security.users.read' },
      component: User
    },
    {
      path: '/entrada',
      name: 'Income',
      meta: { permission: 'plant.incomes.read' },
      component: Income
    },
    {
      path: '/salida',
      name: 'Outcome',
      meta: { permission: 'plant.outcomes.read' },
      component: Outcome
    },
    {
      path: '/proceso',
      name: 'Process',
      meta: { permission: 'plant.processes.read' },
      component: Process
    },
    {
      path: '/agrochemical',
      name: 'Agrochemical',
      meta: { permissions: ['agrochemicals.products.read', 'agrochemicals.withdrawals.read', 'agrochemicals.applications.read'] },
      component: Agrochemical
    },
    {
      path: '/administracion/roles',
      name: 'Roles',
      meta: { permission: 'security.roles.read' },
      component: () => import('@/components/Authorization/Roles.vue')
    },
    {
      path: '/administracion/permisos',
      name: 'Permissions',
      meta: { permission: 'security.permissions.read' },
      component: () => import('@/components/Authorization/Permissions.vue')
    },
    {
      path: '/administracion/auditoria',
      name: 'AuthorizationAudit',
      meta: { permission: 'security.audit.read' },
      component: () => import('@/components/Authorization/AuthorizationAudit.vue')
    },
    {
      path: '/sin-acceso',
      name: 'AccessDenied',
      meta: { sessionOnly: true },
      component: () => import('@/components/Miscellaneous/AccessDenied.vue')
    },
    {
      path: '/:pathMatch(.*)*',
      name: 'NotFound',
      meta: { sessionOnly: true },
      component: NotFound
    }
    /* redirect example
    {
      path: '/private-site',
      redirect: '/login'
    }
    */
  ]
})

export default router
